import {registerRoute as workbox_routing_registerRoute} from '/Users/hello/code/client/axtro-next-api/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/hello/code/client/axtro-next-api/node_modules/workbox-strategies/NetworkFirst.mjs';
import {NetworkOnly as workbox_strategies_NetworkOnly} from '/Users/hello/code/client/axtro-next-api/node_modules/workbox-strategies/NetworkOnly.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/hello/code/client/axtro-next-api/node_modules/workbox-core/clientsClaim.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  
);







self.skipWaiting();

workbox_core_clientsClaim();



workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url", plugins: [{ cacheWillUpdate: async ({ response: e })=>e && "opaqueredirect" === e.type ? new Response(e.body, { status: 200, statusText: "OK", headers: e.headers }) : e }] }), 'GET');
workbox_routing_registerRoute(/.*/i, new workbox_strategies_NetworkOnly({ "cacheName":"dev", plugins: [] }), 'GET');




